var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordExplorerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 1.5C5.19675 1.5 1.5 5.19675 1.5 9.75C1.5 14.3033 5.19675 18 9.75 18C14.3033 18 18 14.3033 18 9.75C18 5.19675 14.3033 1.5 9.75 1.5ZM9.75 3C13.4753 3 16.5 6.02475 16.5 9.75C16.5 13.4753 13.4753 16.5 9.75 16.5C6.02475 16.5 3 13.4753 3 9.75C3 6.02475 6.02475 3 9.75 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15H9C9.414 15 9.75 14.664 9.75 14.25C9.75 13.836 9.414 13.5 9 13.5H7.5C7.086 13.5 6.75 13.836 6.75 14.25C6.75 14.664 7.086 15 7.5 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25099 9H9.00099C9.41474 9 9.751 8.664 9.751 8.25C9.751 7.836 9.41474 7.5 9.00099 7.5H5.25099C4.83723 7.5 4.50098 7.836 4.50098 8.25C4.50098 8.664 4.83723 9 5.25099 9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9H14.25C14.664 9 15 8.664 15 8.25C15 7.836 14.664 7.5 14.25 7.5H12C11.586 7.5 11.25 7.836 11.25 8.25C11.25 8.664 11.586 9 12 9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 12H6.75C7.164 12 7.5 11.664 7.5 11.25C7.5 10.836 7.164 10.5 6.75 10.5H5.25C4.836 10.5 4.5 10.836 4.5 11.25C4.5 11.664 4.836 12 5.25 12Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 12H14.25C14.664 12 15 11.664 15 11.25C15 10.836 14.664 10.5 14.25 10.5H9.75C9.336 10.5 9 10.836 9 11.25C9 11.664 9.336 12 9.75 12Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6H12C12.414 6 12.75 5.664 12.75 5.25C12.75 4.836 12.414 4.5 12 4.5H7.5C7.086 4.5 6.75 4.836 6.75 5.25C6.75 5.664 7.086 6 7.5 6Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2196 16.2801L19.939 21C20.2318 21.2923 20.7072 21.2923 21 21C21.2923 20.7072 21.2923 20.2318 21 19.939L16.2801 15.2196C15.9878 14.9268 15.5124 14.9268 15.2196 15.2196C14.9268 15.5124 14.9268 15.9878 15.2196 16.2801Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12.4142 15 12.75 14.6642 12.75 14.25C12.75 13.8358 12.4142 13.5 12 13.5C11.5858 13.5 11.25 13.8358 11.25 14.25C11.25 14.6642 11.5858 15 12 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordExplorerWhite);
export default __webpack_public_path__ + "static/media/wordExplorerWhite.436de84803a8bd35f1786b1a7595352d.svg";
export { ForwardRef as ReactComponent };